module.exports = __webpack_public_path__ + "static/media/bookmark_inactive.8227eb24.svg";